// Maps v1 site-content docs (cta as string, no per-route cta, no enabled
// flag, gallery items as strings) to v2 (cta as { label, target }, per-route
// cta blocks, enabled defaulted true, gallery items as { url, x?, y?, w? }).
// Idempotent on v2 input. Pure — no I/O, no React.
//
// The defaults below are the v1 implicit behavior: the existing DEEPER link
// pointed at /works/deeper, /works/deeper had no second CTA (introduced
// here), and /works/deeper/:slug had no second CTA (introduced here). The
// chosen defaults are sensible starting values the user can edit.

const DEFAULT_WORK_DETAIL_CTA = { label: "ALL WORKS", target: "/works/deeper" };
const DEFAULT_WORKS_INTRO_CTA_TARGET = "/works/deeper";

function normalizeCta(cta, fallback) {
  if (typeof cta === "string" && cta.trim()) {
    return { label: cta, target: fallback.target };
  }
  if (cta && typeof cta === "object" && cta.label && cta.target && cta.target.trim().length > 0) {
    return { label: String(cta.label), target: String(cta.target) };
  }
  return { ...fallback };
}

function normalizeGallery(g) {
  if (!Array.isArray(g)) return [];
  return g.map((item) => {
    if (typeof item === "string") return { url: item };
    if (item && typeof item === "object" && item.url) {
      const out = { url: String(item.url) };
      if (typeof item.x === "number") out.x = item.x;
      if (typeof item.y === "number") out.y = item.y;
      if (typeof item.w === "number") out.w = item.w;
      return out;
    }
    return { url: "" };
  });
}

export function normalizeContent(doc) {
  if (!doc) return doc;
  const out = { ...doc };

  out.worksIntro = {
    ...doc.worksIntro,
    cta: normalizeCta(doc.worksIntro && doc.worksIntro.cta, {
      label: "DEEPER",
      target: DEFAULT_WORKS_INTRO_CTA_TARGET,
    }),
  };

  out.worksDeeper = {
    ...doc.worksDeeper,
    filmBackdrop:
      doc.worksDeeper && typeof doc.worksDeeper.filmBackdrop === "boolean"
        ? doc.worksDeeper.filmBackdrop
        : false,
    galleryBottomMargin:
      doc.worksDeeper && typeof doc.worksDeeper.galleryBottomMargin === "number"
        ? doc.worksDeeper.galleryBottomMargin
        : 0.5,
  };

  const sr = doc.contact && doc.contact.showreel;
  out.contact = {
    ...doc.contact,
    showreel:
      sr && typeof sr === "object" && typeof sr.url === "string" && sr.url.trim()
        ? { label: typeof sr.label === "string" ? sr.label : "Showreel", url: sr.url.trim() }
        : null,
  };

  out.workDetail = {
    ...(doc.workDetail || {}),
    cta: normalizeCta(doc.workDetail && doc.workDetail.cta, DEFAULT_WORK_DETAIL_CTA),
  };

  out.works = Array.isArray(doc.works)
    ? doc.works.map((w) => {
        const el = w.externalLink;
        const externalLink =
          el && typeof el === "object" && typeof el.url === "string" && el.url.trim()
            ? { label: typeof el.label === "string" ? el.label : "Visit", url: el.url.trim() }
            : null;
        return {
          ...w,
          enabled: typeof w.enabled === "boolean" ? w.enabled : true,
          gallery: normalizeGallery(w.gallery),
          externalLink,
        };
      })
    : [];

  return out;
}
